import * as Yup from 'yup'

import { FILE, FILE_NAME } from './fields'

export const validationSchema = Yup.object({
  [FILE_NAME]: Yup.string().required('File name is required'),
  [FILE]: Yup.string().required('File is required')
})
